"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');


var _X22FP4G7cjs = require('../__chunks/X22FP4G7.cjs');
require('../__chunks/PLY2V46G.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-arrow.tsx
var TagName = "div";
var useMenuArrow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuArrow2({ store, ...props }) {
    const context = _XXF5DFSGcjs.useMenuContext.call(void 0, );
    store = store || context;
    return _X22FP4G7cjs.usePopoverArrow.call(void 0, { store, ...props });
  }
);
var MenuArrow = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuArrow2(props) {
  const htmlProps = useMenuArrow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuArrow = MenuArrow; exports.useMenuArrow = useMenuArrow;
